"use client";import{jsxs as e,jsx as o}from"react/jsx-runtime";import"tailwind-merge";import{Box as s}from"../../Base/Layouts/Box/Box.js";import"../../Base/Layouts/FullBleed/FullBleed.js";import{List as l}from"../List/List.js";import{SupportTextContainer as t}from"../SupportTextContainer/SupportTextContainer.js";import{useDropdown as i}from"../../../hooks/useDropdown.js";import{SelectBox as r}from"./TextFieldDropdown.parts.js";
/**
 * 드롭다운 형태의 텍스트 필드 컴포넌트입니다.
 *
 * @component
 *
 * @param {Object} props
 * @param {Item[]} props.items - 드롭다운에 표시될 아이템 배열 ({key, value, leadingIcon}[])
 * @param {string} props.placeholder - 선택되지 않은 상태에서 표시될 안내 텍스트
 * @param {(item: Item) => void} props.onItemClick - 아이템 선택 시 호출되는 콜백 함수
 * @param {Item} [props.selectedItem] - 현재 선택된 아이템
 * @param {boolean} [props.disabled] - 비활성화 여부
 * @param {string} [props.supportMessage] - 입력 필드 아래에 표시될 도움말 메시지
 * @param {string} [props.errorMessage] - 오류 발생 시 표시될 메시지
 * @param {string} [props.className] - 추가적인 CSS 클래스명
 * @param {boolean} [props.isError] - 오류 상태 여부
 *
 * @example
 * ```tsx
 * const items = [
 *   { key: 1, value: '옵션 1', leadingIcon: 'home' },
 *   { key: 2, value: '옵션 2', leadingIcon: 'settings' }
 * ];
 *
 * <TextFieldDropdown
 *   items={items}
 *   placeholder="옵션을 선택하세요"
 *   onItemClick={(item) => console.log('선택된 아이템:', item)}
 *   selectedItem={items[0]}
 *   supportMessage="추가 설명이 필요한 경우 이곳에 표시됩니다"
 * />
 * ```
 */const n=({selectedItem:n,items:a,onItemClick:d,placeholder:p,disabled:m,isError:c,errorMessage:u,supportMessage:x,className:f})=>{const{isListOpen:g,focusedIndex:I,ref:k,handleItemClick:h,toggleListOpen:v,handleKeyDown:w}=i({items:a,onItemClick:d,disabled:m}),y=!!x||!!u;/*#__PURE__*/
return e("div",{"data-testid":"design-system--textFieldDropdown",ref:k,className:"relative flex w-full flex-col gap-2 outline-none",onKeyDown:w,tabIndex:0,children:[
/*#__PURE__*/o(r,{placeholder:p,value:null==n?void 0:n.value,leadingIcon:null==n?void 0:n.leadingIcon,disabled:m,isListOpen:g,onClick:v,error:c,className:f}),y&&/*#__PURE__*/o(t,{errorMessage:u,supportMessage:x}),g&&/*#__PURE__*/o(s,{className:"absolute top-[54px] z-40 w-full",children:/*#__PURE__*/o(l.Root,{children:a.map(((e,s)=>/*#__PURE__*/o(l.Item,{text:e.value,leadingIcon:e.leadingIcon,onClick:()=>h(e),selected:e.key===(null==n?void 0:n.key),isFocused:s===I},e.key)))})})]})};export{n as TextFieldDropdown};
